import { ListLayout } from 'components/common/ListLayout';
import TableHeaderItem from 'components/common/ListLayout/TableHeaderItem';
import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { DashboardSelector } from 'slices/dashboardSlice';
import { fetchVendorReliability } from 'slices/dashboardSlice';

const VendorReliabilityTable = ({ paginationParams, filterKey }) => {
    const dispatch = useDispatch();

    const [searchTerm, setSearchTerm] = React.useState("");
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'give_back_rate',
        sortDirection: 'desc',
    });

    const { vendorReliability } = useSelector(DashboardSelector);
    const { data = [], total = 0, last_page: totalPages = 1, current_page = 1, per_page: pageLength = 10 } = vendorReliability || {};

    React.useEffect(() => {
        setSearchTerm("");
    }, [filterKey])

    //#region TABLE HEAD
    const renderTableHeader = React.useCallback(() => {
        const callBack = (dir, sortBy) => {
            setSortConfig({ sortBy, sortDirection: dir })
            dispatch(fetchVendorReliability(1, { sortBy, sortDirection: dir, search: searchTerm, pageLength, ...paginationParams }))
        }

        return (
            <tr>
                <th>#</th>
                <th>
                    <TableHeaderItem title="Vendor" sortBy="vendor_name" sortDirection={sortConfig.sortDirection} callBack={callBack} />
                </th>
                <th>
                    <TableHeaderItem title="Jobs Taken" sortBy="taken" sortDirection={sortConfig.sortDirection} callBack={callBack} />
                </th>
                <th>
                    <TableHeaderItem title="Jobs Given Back" sortBy="given_back" sortDirection={sortConfig.sortDirection} callBack={callBack} />
                </th>
                <th>
                    <TableHeaderItem title="Give-Back Rate" sortBy="give_back_rate" sortDirection={sortConfig.sortDirection} callBack={callBack} />
                </th>
            </tr>
        )
    }, [searchTerm, sortConfig, paginationParams, pageLength]);
    //#endregion

    //#region TABLE BODY
    const renderTableContent = React.useCallback(() => {
        return (
            data && data.length > 0 ? data.map((item, index) => (
                <VendorReliabilityRow key={item.vendor_id} item={item} index={index} current_page={current_page} pageLength={pageLength} />
            )) : <tr><td colSpan={5} className="text-center">No data</td></tr>
        )
    }, [data, current_page, pageLength]);
    //#endregion

    return (
        <div className='mt-4'>
            <ListLayout
                heading={`Vendor Reliability`}
                time={false}
                fullMainHead={'ms-3'}
                title=""
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                fetchList={fetchVendorReliability}
                initialPageLength={10}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                searchPlaceholder="Search by vendor ..."
                addButtonDisabled={true}
                totalPages={totalPages}
                sortConfig={sortConfig}
                noOfItems={total}
                paginationParams={paginationParams}
                apiCurrentPage={current_page}
                filterKey={filterKey}
            />
        </div>
    )
}

const VendorReliabilityRow = React.memo(({ item, index, current_page, pageLength }) => {
    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [index, current_page, pageLength]);

    return (
        <tr>
            <td>{serial}</td>
            <td>{item?.vendor_name || 'N/A'}</td>
            <td>{item?.taken}</td>
            <td>{item?.given_back}</td>
            <td>{item?.give_back_rate}%</td>
        </tr>
    )
})

export default VendorReliabilityTable
